import React, { memo, useCallback } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import { coreEdgeStyle } from './edges/coreEdgeStyleDef';
import { Box } from '@mui/material';

const EDGE_COLORS = [
  'green',
  'blue',
  'red',
  'purple',
  'orange',
  'yellow',
  '#90EE90',
  '#ADD8E6',
  '#FFC0CB',
  '#E6E6FA',
  '#FFD700',
  '#FFFFE0',
];

interface Props {
  isConnectable: boolean;
  nodeId: string;
  sourceName: string;
  style?: React.CSSProperties;
  position: Position;
  setActiveSourceName?: (sourceName: string) => void;
  className?: string;
}

const SourceHandle = ({
  isConnectable,
  nodeId,
  sourceName,
  style,
  position,
  setActiveSourceName,
  className,
}: Props) => {
  const { setEdges, getEdges } = useReactFlow();
  const handleEdgeColors = useCallback(() => {
    let colorIndex = 0;
    const coloredEdges = getEdges().map(edge => {
      if (edge.source === nodeId && edge.sourceHandle === sourceName) {
        const updatedEdge = {
          ...edge,
          style: {
            ...edge.style,
            stroke: EDGE_COLORS[colorIndex],
            strokeWidth: 10,
          },
          type: 'coloredEdge',
          markerEnd: coreEdgeStyle.markerEndCustom,

          data: {
            coloredEdge: true,
            coloredFromSource: true,
            coloredFromTarget: false,
          },
        };

        colorIndex = (colorIndex + 1) % EDGE_COLORS.length; // Cycle through colors
        return updatedEdge;
      }
      return {
        ...edge,
        style: {
          ...edge.style,
          stroke: '#6e75ff',
          strokeWidth: 1,
        },
        type: edge.type === 'custom' ? 'custom' : '',
        markerEnd: edge.type === 'custom' ? undefined : coreEdgeStyle.markerEnd,
        data: {
          coloredEdge: false,
        },
      };
    });

    setEdges(coloredEdges);
  }, [getEdges, setEdges, nodeId, sourceName]);
  return (
    <Box>
      <Handle
        type='source'
        position={position}
        id={sourceName}
        isConnectable={isConnectable}
        className={className}
        style={style}
        onClick={e => {
          e.stopPropagation();
          setActiveSourceName?.(sourceName);
          handleEdgeColors();
        }}
      />
    </Box>
  );
};

export default memo(SourceHandle);
